export const downloadCSV = (CSV, ReportTitle) => {
  //If JSONData is not an object then JSON.parse will parse the JSON string in an Object

  if (CSV === "") {
    alert("Invalid data");
    return;
  }

  //Generate a file name
  let fileName = "Flash_Coach_";
  //this will remove the blank-spaces from the title and replace it with an underscore
  fileName += ReportTitle.replace(/ /g, "_");

  //Initialize file format you want csv or xls
  const uri = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(CSV);

  // Now the little tricky part.
  // you can use either>> window.open(uri);
  // but this will not work in some browsers
  // or you will not get the correct file extension

  //this trick will generate a temp <a /> tag
  let link = document.createElement("a");
  link.href = uri;

  //set the visibility hidden so it will not effect on your web-layout
  link.style = "visibility:hidden";
  link.download = fileName + ".csv";

  //this part will append the anchor tag and remove it after automatic click
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
